import React from 'react';

import { FlexLayout } from '@swyftx/aviary/atoms/Layout/Flex';
import { Numeric } from '@swyftx/aviary/atoms/Typography';

import { Big } from '@shared/safe-big';
import { formatCurrency } from '@shared/utils';

import { observer } from 'mobx-react-lite';
import { useMarginAccount } from 'src/lib/margin/hooks/account';
import { useMarginPositionDetails } from 'src/lib/margin/hooks/positions';

type Props = {
  positionId?: string;
};

const MarginPositionsTableProfitLoss: React.FC<Props> = observer(({ positionId }) => {
  const { profitLoss } = useMarginPositionDetails({ positionId });
  const { currency } = useMarginAccount();

  return (
    <FlexLayout spacing={4} justifyContent='end'>
      <Numeric color={Big(profitLoss).gte(0) ? 'success' : 'error'} weight='bold'>
        {profitLoss?.gte(0) ? '+' : ''}
        {formatCurrency(profitLoss, currency)}
      </Numeric>
      <Numeric color={Big(profitLoss).gte(0) ? 'success' : 'error'}>AUD</Numeric>
    </FlexLayout>
  );
});

export { MarginPositionsTableProfitLoss };
